
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M400 0c-61.8 0-112 50.2-112 112 0 57.5 89.9 159.3 100.1 170.7 3 3.4 7.4 5.3 11.9 5.3s8.9-2 11.9-5.3C422.1 271.3 512 169.5 512 112 512 50.2 461.8 0 400 0zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM10 188c-6 2.4-10 8.3-10 14.8V496c0 5.3 2.7 10.3 7 13.2 2.7 1.8 5.8 2.8 9 2.8 2 0 4-.4 6-1.2l138-55.2V128L10 188z"}}),_c('path',{attrs:{"d":"M435.7 304.1c-9.1 10.1-22.1 15.9-35.7 15.9-13.6 0-26.6-5.8-35.7-15.9-3.3-3.6-7.5-8.4-12.3-14V512l150-60c6.1-2.4 10-8.3 10-14.8V202c-26.2 44.3-61.2 85.3-76.3 102.1zM266.1 157.6L192 128v327.6l128 51.2v-257c-20.4-27.5-41.8-60.7-53.9-92.2z"}})])
          )
        }
      }
    